import React, { useContext, useEffect } from "react";
import DayPartingTimePickerContainer from "./DayPartingTimePickerContainer";
import { mainContext } from "@ts/constants";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { updateDaypartingDataObject } from "@features/modalSlice";
import ToggleSwitch from "@buttons/ToggleSwitch";
import { dprToggleChangeHandler } from "@ts/day-parting";
import {
    IMainContext,
    TDayPartingDisplay,
    TDaypartingDataObject,
    TIsDaypartingEdit,
} from "@ts/common-types";
interface IDaypartingCards {
    day: string;
    canManageDayParting: boolean
}

const DayPartingCards: React.FC<IDaypartingCards> = ({ day, canManageDayParting }) => {
    const {
        dprTimeSlots,
        setDprTimeSlots,
        daypartingCardCheckedData,
        setDaypartingCardCheckedData,
    } = useContext<IMainContext>(mainContext);
    const isDaypartingEdit = useSelector(
        (state: TIsDaypartingEdit) => state.isDaypartingEdit.value
    );
    const currentDay = day.toLowerCase();
    const daypartingDataObject = useSelector(
        (state: TDaypartingDataObject) => state.daypartingDataObject.value
    );
    const currentDayArr = daypartingDataObject[currentDay];
    const dispatch = useDispatch();
    const maxLength = 10;
    const dayPartingDisplay = useSelector(
        (state: TDayPartingDisplay) => state.dayPartingDisplay.value
    );
    const addDatesClickHandler = () => {
        const currentUpdatedArr = [
            ...currentDayArr,
            currentDayArr[currentDayArr.length - 1] + 1,
        ];
        const updatedDaypartingData = {
            ...daypartingDataObject,
        };
        updatedDaypartingData[currentDay] = currentUpdatedArr;
        dispatch(updateDaypartingDataObject(updatedDaypartingData));
    };
    const onTimeCardHandler = (key: number) => {
        if (currentDayArr.length === 1) {
            $(`#${currentDay}-start-time-${key}`).val("");
            $(`#${currentDay}-end-time-${key}`).val("");
            $(`#${currentDay}-end-time-${key}`).prop("disabled", true);
            $(`#${currentDay}-time-card-${key}`).css(
                "background-color",
                "rgb(0, 158, 255, 0.15)"
            );

            delete dprTimeSlots[currentDay]["state"];
        } else {
            const availableDataArr = [...currentDayArr];
            availableDataArr.splice(availableDataArr.indexOf(key), 1);
            const updatedDaypartingData = {
                ...daypartingDataObject,
            };
            updatedDaypartingData[currentDay] = availableDataArr;
            dispatch(updateDaypartingDataObject(updatedDaypartingData));
            $(`#${currentDay}-time-card-${key}`).css("display", "none");
        }
        delete dprTimeSlots[currentDay][`slot-${key}`];
        delete daypartingCardCheckedData[currentDay][`slot-${key}`];
        const updatedSlots = { ...dprTimeSlots };
        setDprTimeSlots(updatedSlots);
        const updatedDaypartingCardCheckedData = { ...daypartingCardCheckedData };
        setDaypartingCardCheckedData(updatedDaypartingCardCheckedData);
    };

    useEffect(() => {
        if (dayPartingDisplay && currentDayArr.length) {
            const button = document.querySelector(
                `#add-time-card-btn-${currentDay}`
            ) as HTMLElement;
            if (button) {
                button.style.display = currentDayArr.length < maxLength ? "unset" : "none";
                button.style.pointerEvents = canManageDayParting ? "auto" : "none"
            }
        }
        // eslint-disable-next-line
    }, [currentDayArr, canManageDayParting]);

    return (
        <div
            className="card bg-white mx-1 w-100 h-auto"
            id={`${currentDay}-card`}
            key={`day-parting-${currentDay}`}

        >
            <div className="card-header card-header-container">
                {isDaypartingEdit ? (
                    <>
                        <label>{day}</label>
                        <div style={{ marginTop: "5px" }}>
                            <ToggleSwitch
                                id={`toggle-${currentDay}-dpr`}
                                onToggleChange={() =>
                                    dprToggleChangeHandler(
                                        dprTimeSlots,
                                        setDprTimeSlots,
                                        currentDay
                                    )
                                }
                                size={"0.7rem"}
                                disabled={!canManageDayParting}
                            />
                        </div>
                    </>
                ) : (
                    <label>{day}</label>
                )}
            </div>

            <div className="p-2">
                <div id={`${currentDay}-slot-container`}>
                    {daypartingDataObject[currentDay].map((key: number) => (
                        <DayPartingTimePickerContainer
                            containerKey={key}
                            onTimeCardHandler={onTimeCardHandler}
                            day={currentDay}
                            canManageDayParting={canManageDayParting}
                            {...{
                                dprTimeSlots,
                                setDprTimeSlots,
                                daypartingCardCheckedData,
                                setDaypartingCardCheckedData,
                            }}
                        />
                    ))}
                </div>
                <div
                    id={`add-time-card-btn-${currentDay}`}
                    style={{ display: "none" }}
                >
                    <label
                        id={`add-time-card-btn-label-${currentDay} pe-none`}
                        onClick={addDatesClickHandler}
                        style={{
                            color: "#009EFF",
                            float: "right",
                        }}
                        role="button"
                    >
                        Add more
                    </label>
                </div>
            </div>
        </div>
    );
};

export default DayPartingCards;
